<template>
    <v-container class="unauthorized" fluid>
        <section class="unauthorized__card" aria-labelledby="unauthorized-title">
            <span class="unauthorized__icon" aria-hidden="true">
                <i class="fas fa-lock"></i>
            </span>
            <h1 id="unauthorized-title" class="unauthorized__title">No tienes acceso a esta pantalla</h1>
            <p class="unauthorized__text">
                Tu rol no incluye este módulo. Si lo necesitas para tu trabajo,
                pide al administrador que te lo habilite.
            </p>
            <div class="unauthorized__actions">
                <v-btn color="primary" to="/controlPanel">Ir al inicio</v-btn>
                <v-btn text @click="goBack">Volver</v-btn>
            </div>
        </section>
    </v-container>
</template>

<script>
export default {
    name: 'Unauthorized',
    methods: {
        // Sin historial (se abrió por enlace directo), "Volver" lleva al inicio.
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/controlPanel');
            }
        }
    }
}
</script>
<style scoped>
.unauthorized {
    display: flex;
    justify-content: center;
    padding-top: 64px;
}
.unauthorized__card {
    width: 100%;
    max-width: 440px;
    padding: 32px 28px;
    border: 1px solid var(--app-line);
    border-radius: 12px;
    background: var(--app-surface);
    text-align: center;
}
.unauthorized__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    margin-bottom: 16px;
    border-radius: 50%;
    background: var(--app-primary-soft);
    color: var(--app-primary);
    font-size: 20px;
}
.unauthorized__title {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.3;
}
.unauthorized__text {
    margin: 8px 0 24px;
    font-size: 14px;
    color: var(--app-text-muted);
}
.unauthorized__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
}
</style>
